module.exports = __webpack_public_path__ + "media/brands/volkswagen-86067d03.png";